import { DatePicker, type DatePickerProps } from '@mui/x-date-pickers';
import { type Moment } from 'moment';
import styled from '@emotion/styled';
import { IconButton, Tooltip } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

const DatePickerControlsWrapper = styled('div')({
  marginTop: 10,
  display: 'flex',
  alignItems: 'center',
});

type VisibilityDatePickerProps = {
  variant: 'visible_from' | 'visible_until';
  value: Moment | null;
  onChange: DatePickerProps['onChange'];
  onClear: () => void;
  shouldDisableDate: DatePickerProps['shouldDisableDate'];
};

const VisibilityDatePicker = ({
  variant,
  value,
  onClear,
  ...props
}: VisibilityDatePickerProps) => (
  <DatePickerControlsWrapper>
    <DatePicker
      label={
        <FormattedMessage
          id={`editor.model_editor.visibility_dates_manager.dialog.date_picker.labels.${variant}`}
        />
      }
      value={value}
      slotProps={{
        textField: {
          size: 'small',
        },
      }}
      {...props}
    />
    {value !== null && (
      <Tooltip
        title={
          <FormattedMessage id="editor.model_editor.visibility_dates_manager.dialog.date_picker.clear_button" />
        }
      >
        <IconButton onClick={onClear}>
          <ClearIcon />
        </IconButton>
      </Tooltip>
    )}
  </DatePickerControlsWrapper>
);

export default VisibilityDatePicker;
